import { buildProps } from '@pit-element-plus/utils'
import type { ExtractPropTypes } from 'vue'
import type LayoutColumn from './layout-column.vue'

export const layoutColumnProps = buildProps({
  /**
   * @description title
   */
  title: {
    type: String,
    default: '菜单管理',
  },
  /**
   * @description noTitle
   */
  noTitle: {
    type: Boolean,
    default: true,
  },
  /**
   * @description width
   */
  width: {
    type: String,
    default: '260px',
  },
  /**
   * @description isScrollbar
   */
  isScrollbar: {
    type: Boolean,
    default: true,
  },
} as const)

export type LayoutColumnProps = ExtractPropTypes<typeof layoutColumnProps>
export type LayoutColumnInstance = InstanceType<typeof LayoutColumn>
